import { render, staticRenderFns } from "./ConfirmSubmitAnnouncement.vue?vue&type=template&id=6f2707a6&scoped=true&"
import script from "./ConfirmSubmitAnnouncement.vue?vue&type=script&lang=ts&"
export * from "./ConfirmSubmitAnnouncement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2707a6",
  null
  
)

export default component.exports